module.exports = __webpack_public_path__ + "static/media/sparkles.7a2ecdd6.svg";